import { render, staticRenderFns } from "./rvlistshow.vue?vue&type=template&id=1fa24e23"
import script from "./rvlistshow.vue?vue&type=script&lang=js"
export * from "./rvlistshow.vue?vue&type=script&lang=js"
import style0 from "./rvlistshow.vue?vue&type=style&index=0&id=1fa24e23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports